import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthService } from '../../../core/services/auth.service';
import { CoreService } from '../../../core/services/core.service';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
})
export class AccountSettingsComponent implements OnInit {
  userId = '';

  newEmail = '';
  emailLoading = false;
  emailSuccess: string | null = null;
  emailError: string | null = null;

  readonly displayName$ = this.auth.displayName$;
  readonly profile$ = this.auth.profile$;

  constructor(
    private readonly auth: AuthService,
    private readonly core: CoreService,
  ) {}

  ngOnInit(): void {
    this.auth.currentUser$.pipe(take(1)).subscribe(user => {
      this.userId = user?.userId ?? '';
    });
  }

  updateEmail(): void {
    const trimmed = this.newEmail.trim();
    if (!trimmed) return;

    this.emailLoading = true;
    this.emailSuccess = null;
    this.emailError = null;

    this.core.updateEmail(trimmed).subscribe({
      next: (res) => {
        this.emailSuccess = res.message;
        this.emailLoading = false;
        this.newEmail = '';
      },
      error: (err: { error?: { message?: string } }) => {
        this.emailError = err?.error?.message ?? 'Failed to submit email update. Please try again.';
        this.emailLoading = false;
      },
    });
  }
}
